var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"box__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"box__description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }